import React, { useEffect, useState } from 'react';
import { 
  Button, 
  Modal, 
  ModalHeader, 
  ModalFooter, 
  ModalBody,
} from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import moment from "moment";

import { getMessage } from "CONFIG/i18n";
import { getBootstrapTableOptions } from "UTILS/Utility";

import modalScrollBar from 'COMPONENTS/ModalScrollBar/ModalScrollBar';

import "./TransferDestinationModal.less";

const TransferDestinationModal = (props) => {
  const [selectedOperator, setSelectedOperator] = useState(null);

  useEffect(() => {
    if (!props.show) {
      setSelectedOperator(null);
    }
  },[props.show])

  const handleTransferClick = () => {
    if (selectedOperator) {
      props.handleTransferClick(selectedOperator.userId);
    }
  };

  const handleCancelClick = () => {
    resetError();
    props.handleCancelClick();
  };

  const resetError = () => {
    props.setIsTransferError(false);
  };

  // Sort operators by shortest wait time.
  const operatorList = props.operatorList.map((operator) => {
    return {...operator, fullName: `${operator.lastName} ${operator.firstName}`};
  }).sort((a, b) => {
    return moment(b.waitStartTime).diff(a.waitStartTime);
  });

  return(
    <Modal
      isOpen={props.show}
      className="transferDestinationModal"
    >
      <ModalHeader>
        {getMessage("DESTINATION_SELECTION")}
      </ModalHeader>
      <ModalBody>
        <BootstrapTable
          data={operatorList}
          tableContainerClass='tableContainer'
          headerContainerClass='headerContainer'
          bodyContainerClass='bodyContainer'
          bordered={false}
          options={getBootstrapTableOptions()}
          selectRow={{
            mode: "radio",
            clickToSelect: true,
            hideSelectColumn: false,
            columnWidth: "calc(15px + 1.5rem)",
            bgColor: "#FFF5E6",
            onSelect: (row, isSelected) => {
              if (isSelected) {
                setSelectedOperator(row);
              } else {
                setSelectedOperator(null);
              }
              // Reset error messages when selecting another operator.
              resetError();
            }
          }}
          keyField="userId"
          printable
        >
          <TableHeaderColumn
            dataField='fullName'
          />
        </BootstrapTable>
        {props.isTransferError && 
          <div className="modal-errors">{getMessage("OPERATOR_TRANSFER_ERROR")}</div>}
      </ModalBody>
      <ModalFooter className="permissionButtons">
        <Button
          onClick={handleCancelClick}
          className="buttons width-25 cancelBtn"
        >
          {getMessage("CANCEL")}
        </Button>
        <Button
          onClick={handleTransferClick}
          className="buttons width-25 transferBtn"
          disabled={!selectedOperator}
        >
          {getMessage("TRANSFER")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default modalScrollBar(TransferDestinationModal);
